import React, { useState } from 'react'
import styled from 'styled-components'
import brandLogos from './assets/brands.js'
import WaveSection from '../../global/WaveSection'
import { useTranslation } from 'react-i18next'
import chevron from './assets/chevron.svg'
const FeaturedIn = () => {
  const { t, i18n } = useTranslation()
  const lang = i18n.language
  const brands = ["en", "de"].includes(lang) ? brandLogos[lang] : brandLogos["en"]
  const [currentSlide, setCurrentSlide] = useState(0)
  
  const itemsPerRow = typeof window !== 'undefined' ? (window.innerWidth < 768 ? 2 : window.innerWidth < 1024 ? 3 : 4) : 4
  const totalSlides = Math.ceil(brands.length / (itemsPerRow * 2))

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % totalSlides)
  }

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + totalSlides) % totalSlides)
  }

  // Split brands into groups of 8 (4 per row * 2 rows)
  const groupedBrands = []
  for (let i = 0; i < brands.length; i += itemsPerRow * 2) {
    groupedBrands.push(brands.slice(i, i + itemsPerRow * 2))
  }

  return (
    <WaveSection>
      <Title >{t('root.featuredInTitle')}</Title>
      <SliderContainer>
        <SliderButton onClick={prevSlide}><Chevron src={chevron} alt="chevron" $forward={true} /></SliderButton>
        <Wrapper>
          <SliderTrack style={{ transform: `translateX(-${currentSlide * 100}%)` }}>
            {groupedBrands.map((group, groupIndex) => (
              <SlideGroup key={groupIndex}>
                <Row>
                  {group.slice(0, itemsPerRow).map((x, index) => (
                    <LogoWrapper href={x.link} target="_blank" rel="noopener noreferrer" key={`${groupIndex}-${index}`}>
                      <Logo src={x.logo} alt={`featured in brand logo ${index}`}/>
                    </LogoWrapper>
                  ))}
                </Row>
                <Row>
                  {group.slice(itemsPerRow).map((x, index) => (
                    <LogoWrapper href={x.link} target="_blank" rel="noopener noreferrer" key={`${groupIndex}-${index + itemsPerRow}`}>
                      <Logo src={x.logo} alt={`featured in brand logo ${index + itemsPerRow}`}/>
                    </LogoWrapper>
                  ))}
                </Row>
              </SlideGroup>
            ))}
          </SliderTrack>
        </Wrapper>
        <SliderButton onClick={nextSlide}><Chevron src={chevron} alt="chevron" /></SliderButton>
      </SliderContainer>
    </WaveSection>
  )
}

export default FeaturedIn

const Chevron = styled.img`
  width: 24px;
  height: 24px;
  transform: ${props => props.$forward ? 'rotate(90deg)' : 'rotate(-90deg)'};
  scale: 0.7;
`

const SliderContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  max-width: 90%;
  margin: 0 auto;
  padding-bottom: 32px;
`;

const SliderButton = styled.button`
  background-color: #F19D9A;  
  border: none;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  cursor: pointer;
  z-index: 2;
  font-size: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  
  &:hover {
    scale: 1.1;
    background-color: #D98179;
  }
`;

const LogoWrapper= styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px;
  width: 25%;
  flex-shrink: 0;
  @media ${props => props.theme.phoneLand} {
    width: 50%;
  }
`;

const Logo = styled.img`
  width: 150px;
  height: 75px;
  object-fit: contain;
  @media ${props => props.theme.phoneLand} {
    width: 120px;
    height: 60px;
  }
`;

const Wrapper = styled.div`
  overflow: hidden;
  width: 100%;
`;

const SliderTrack = styled.div`
  display: flex;
  width: 100%;
  transition: transform 0.5s ease;
`;

const SlideGroup = styled.div`
  min-width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const Row = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  width: 100%;
`;

const Title = styled.h2`
  font-size: 32px;
  text-align: center;
  @media ${props => props.theme.phoneLand} {
    font-size: 2rem;
    text-align: center;
  }
`